import { buttonVariants } from "../button/button-variants.ts";
import { PendingLabel } from "../spinner/spinner.tsx";

import type { ReactElement } from "react";

export interface LinkButtonProps {
  readonly href: string;
  readonly children: string;
  readonly accessibleName?: string;
  readonly variant?: "primary" | "secondary";
  readonly isExternal?: boolean;
  readonly isPending?: boolean;
}

export const LinkButton = ({
  href,
  children,
  accessibleName,
  variant = "primary",
  isExternal = false,
  isPending = false,
}: LinkButtonProps): ReactElement => (
  <a
    href={href}
    aria-busy={isPending}
    onClick={(event) => {
      if (isPending) {
        event.preventDefault();
      }
    }}
    className={buttonVariants({ variant })}
    {...(isExternal && { target: "_blank", rel: "noopener noreferrer" })}
    {...(accessibleName === undefined ? {} : { "aria-label": accessibleName })}
  >
    <PendingLabel isPending={isPending}>{children}</PendingLabel>
  </a>
);
